import { apiGetMembers } from '../Api/Profile/Profile';
import { BANETTE } from '../Config/Config';


export const fetchBenef = async (type) => {
  const res = await apiGetMembers();
  if (!res || !res.benificiaries || !res.benificiaries.length) {
    return [];
  }

  const filterBeneficiaryData = (beneficiary) => {
    return {
      birthDate: beneficiary.birthDate,
      codeAdherent: beneficiary.codeAdherent,
      firstName: beneficiary.firstName,
      lastName: beneficiary.lastName,
      securityNumber: beneficiary.securityNumber,
      typeAdherent: beneficiary.typeAdherent,
    };
  };



  const createItems = (beneficiaries) =>
    beneficiaries.map((benef) => {
      const filteredBenef = filterBeneficiaryData(benef);
      const fullname = `${filteredBenef.firstName} ${filteredBenef.lastName}`;
      return {
        key: fullname,  // clé unique
        value: filteredBenef,
        text: fullname,
      };
    });

  const enfants = res.benificiaries.filter((benef) => benef?.typeAdherent === 'Enfant');
  const autres = res.benificiaries.filter((benef) => benef?.typeAdherent !== 'Enfant');

  let benefItems = type.toLowerCase() !== BANETTE.JUSTIFICATIF_MAINTIEN_ENFANT
    ? [...createItems(enfants), ...createItems(autres)]
    : createItems(enfants);

  return benefItems;
};